import $ from 'jquery';

export default {
  mounted(el, binding) {
    if (typeof $ === 'undefined' && typeof window.$ === 'undefined') {
      // jQuery not available for cpfCnpj directive - handled silently
      return;
    }

    const jq = $ || window.$;
    const sanitizedId = el.id ? el.id.replace(/[^a-zA-Z0-9_-]/g, '') : '';
    const id = '#' + sanitizedId;

    const applyMask = () => {
      if (!jq(id).length) {
        return;
      }

      jq(id).unmask();

      const tamanho = jq(id)[0].value.length;

      if (tamanho < 11) {
        jq(id).mask('999.999.999-99');
      } else {
        jq(id).mask('99.999.999/9999-99');
      }

      setTimeout(() => {
        el.selectionStart = el.selectionEnd = 10000;
      }, 0);

      const currentValue = binding.value;
      jq(id).val('');
      jq(id).val(currentValue);
    };

    jq(function () {
      applyMask();
      jq(id).on('input', applyMask);
    });

    el.__cpfCnpjCleanup__ = () => jq(id).off('input', applyMask);
  },

  unmounted(el) {
    if (el.__cpfCnpjCleanup__) {
      el.__cpfCnpjCleanup__();
    }
  },
};

export function maskCpfCnpj(id) {
  const sanitizedId = typeof id === 'string' ? id.replace(/[^#a-zA-Z0-9_.-]/g, '') : '';
  if (!sanitizedId) {
    return;
  }

  $(sanitizedId).keydown(function () {
    try {
      $(sanitizedId).unmask();
    } catch (e) {
      // Unmask error can be safely ignored
    }

    var tamanho = $(sanitizedId).val().length;

    if (tamanho < 11) {
      $(sanitizedId).mask('999.999.999-99');
    } else if (tamanho >= 11) {
      $(sanitizedId).mask('99.999.999/9999-99');
    }
    var elem = this;
    setTimeout(function () {
      elem.selectionStart = elem.selectionEnd = 10000;
    }, 0);
    var currentValue = $(this).val();
    $(this).val('');
    $(this).val(currentValue);
  });
}
